import { brandColor } from '../../util/ColorUtil';
import { useRouter } from 'next/router';
import {
  getEditorColors,
  isItUndefined,
  modifyLinks,
  replaceGlobalMetrics,
} from '../../util/DataUtil';
import { useEffect, useState } from 'react';
import { getObjectValueByMachineName } from '../../util/ObjectUtil';
import { cleanHTML } from '../utils/htmlUtils';
import { useStaggeredRevealByTwo } from '../../hooks/useStaggeredRevealByTwo';
import PulsePingIcon from '../icons/PulsePingIcon';

const PING_MS = 1050;
const TEXT_FADE_MS = 260;

const NumberList = ({ data, global, width }) => {
  const items = data?.field_number_list?.title_text_paragraph_type || [];

  const { ref: numberListRef, entered } = useStaggeredRevealByTwo({
    total: items.length,
    threshold: 0.1,
  });

  const [batch, setBatch] = useState(-1);
  const [revealed, setRevealed] = useState(() => items.map(() => false));
  const [textVisible, setTextVisible] = useState(() => items.map(() => false));
  const [playKeys, setPlayKeys] = useState(() => items.map(() => 0));

  const router = useRouter();
  const { locale } = router;

  const isOnlyStats =
    data?.field_number_list_stats?.stats_coloured_fields_type.length ===
      undefined &&
    data?.field_number_list_title[0]?.value === undefined &&
    data?.field_number_list_cta_text[0]?.value === undefined &&
    data?.field_number_list_description[0]?.value === undefined;
  const emphasizedTextColor = getEditorColors(
    isItUndefined(data?.field_number_list_title),
    isItUndefined(data?.field_number_list_description)
  ).filter((x) => x)[0];
  const [titleHeight, setTitleHeight] = useState(0);
  const [marginTop, setMarginTop] = useState('0px');

  const alignTitleHeight = () => {
    let titleHeights = document.getElementsByClassName('value');
    let titleCounts = titleHeights.length;
    let max = 0;

    for (let i = 0; i < titleCounts; i++) {
      if (titleHeights[i].clientHeight <= max) {
        continue;
      }

      max = titleHeights[i].clientHeight;
    }

    if (width >= 576) {
      setTitleHeight(max);
    }
  };

  const setMargin = () => {
    setMarginTop(
      data?.field_number_list?.title_text_paragraph_type.length
        ? // (isOnlyStats ? '0px' : (width >= 1220 ? '160px' : '0px')) :
          // '0px')
          isOnlyStats
          ? '0px'
          : '80px'
        : '0px'
    );
  };

  useEffect(() => {
    alignTitleHeight();
    setMargin();
  }, [data, width]);

  useEffect(() => {
    setBatch(-1);
    setRevealed(items.map(() => false));
    setTextVisible(items.map(() => false));
    setPlayKeys(items.map(() => 0));
  }, [items.length]);

  // ✅ start kad uđe u viewport (isto kao Highlight)
  useEffect(() => {
    setBatch(-1);
    setRevealed(items.map(() => false));
    setTextVisible(items.map(() => false));
    setPlayKeys(items.map(() => 0));

    if (entered) setBatch(0);
  }, [entered, items.length]);

  useEffect(() => {
    if (!entered) return;
    if (batch < 0) return;

    const step = width >= 992 ? 3 : width >= 576 ? 2 : 1;

    const start = batch * step;
    const end = Math.min(items.length, start + step);
    if (start >= items.length) return;

    setRevealed((prev) => {
      const next = [...prev];
      for (let i = start; i < end; i++) next[i] = true;
      return next;
    });

    setTextVisible((prev) => {
      const next = [...prev];
      for (let i = start; i < end; i++) next[i] = true;
      return next;
    });

    setPlayKeys((prev) => {
      const next = [...prev];
      for (let i = start; i < end; i++) next[i] = (next[i] || 0) + 1;
      return next;
    });

    const tNext = setTimeout(
      () => setBatch((b) => b + 1),
      PING_MS + TEXT_FADE_MS
    );
    return () => clearTimeout(tNext);
  }, [batch, entered, items.length, width]);

  const renderStats = (items, global) => {
    if (!items) {
      return '';
    }

    return items.map((item, index) => {
      return (
        <div key={`stat-${item?.field_description_formatted?.[0]?.value || index}`} className={'stat'}>
          <span
            dangerouslySetInnerHTML={{
              __html: getObjectValueByMachineName(
                item?.field_description_formatted[0]?.value,
                global
              ),
            }}
            className={'value'}
          />
          <span
            dangerouslySetInnerHTML={{
              __html: getObjectValueByMachineName(
                item?.field_value_formatted[0]?.value,
                global
              ),
            }}
            className={'label'}
          />
        </div>
      );
    });
  };

  const renderItems = (items, data, global) => {
    if (!items) {
      return '';
    }

    return items.map((item, index) => {
      const isRevealed = !!revealed[index];
      const isTextOn = !!textVisible[index];
      const playKey = playKeys[index] || 0;

      return (
        <div
          key={`stat-${item?.field_title_p?.[0]?.value || index}`}
          className={`stat ${isRevealed ? 'nl-reveal--on' : ''}`}
        >
          {/* INDEX UVEK */}
          {isRevealed ? (
            <span
              className="index nl-index"
              style={{
                color: brandColor(
                  data?.field_number_list_font_color?.[0]?.value
                ),
                backgroundColor: brandColor(
                  data?.field_number_list_background_col?.[0]?.value
                ),
              }}
              onMouseEnter={() => {
                if (!isRevealed) return;
                setPlayKeys((prev) => {
                  const next = [...prev];
                  next[index] = (next[index] || 0) + 1;
                  return next;
                });
              }}
            >
              <span
                className="nl-ping"
                aria-hidden="true"
                style={{ color: 'inherit' }}
              >
                <PulsePingIcon
                  bgColor={brandColor(
                    data?.field_number_list_background_col[0]?.value
                  )}
                  playKey={playKey}
                  index={index}
                />
              </span>

              {/* <span className="nl-index__text">{index + 1}</span> */}
            </span>
          ) : null}

          {/* TITLE */}
          {item?.field_title_p?.[0]?.value && (
            <span
              className={`value nl-text ${isTextOn ? 'nl-text--on' : ''}`}
              style={{ height: titleHeight > 0 ? titleHeight : '' }}
              dangerouslySetInnerHTML={{
                __html: global
                  ? replaceGlobalMetrics(item?.field_title_p[0]?.value, global)
                  : '',
              }}
            />
          )}

          {/* DESC */}
          {item?.field_text_p?.[0]?.value && (
            <span
              className={`label nl-text ${isTextOn ? 'nl-text--on' : ''}`}
              dangerouslySetInnerHTML={{
                __html: global
                  ? modifyLinks(
                      replaceGlobalMetrics(
                        item?.field_text_p[0]?.value,
                        global
                      ),
                      locale
                    )
                  : '',
              }}
            />
          )}
        </div>
      );
    });
  };

  return (
    <div
      className={'number-list'}
      style={{
        backgroundColor: brandColor(
          data?.field_number_list_block_backgrou[0]?.value
        ),
      }}
    >
      <div className={'inner-container'}>
        <div className={'top'}>
          <div className={'left'}>
            {data?.field_number_list_title[0]?.value && (
              <span
                dangerouslySetInnerHTML={{
                  __html: cleanHTML(
                    modifyLinks(data?.field_number_list_title[0]?.value, locale)
                  ),
                }}
                className={`${data?.field_number_list_stats?.stats_coloured_fields_type ? 'title width' : 'title'} ${emphasizedTextColor ? emphasizedTextColor : ''}`}
              />
            )}
            {data?.field_number_list_description[0]?.value && (
              <span
                dangerouslySetInnerHTML={{
                  __html: cleanHTML(
                    modifyLinks(
                      data?.field_number_list_description[0]?.value,
                      locale
                    )
                  ),
                }}
                className={`${data?.field_number_list_stats?.stats_coloured_fields_type ? 'subtitle width' : 'subtitle'} ${emphasizedTextColor ? emphasizedTextColor : ''}`}
              />
            )}
            {data?.field_number_list_cta_text[0]?.value && (
              <button
                className={'a-number-list-link'}
                onClick={() => {
                  router.push(data?.field_number_list_cta_link[0]?.value);
                }}
              >
                {data?.field_number_list_cta_text[0]?.value}
              </button>
            )}
          </div>
          {data?.field_number_list_stats?.stats_coloured_fields_type.length >
            0 && (
            <div
              className={
                'right count-' +
                data?.field_number_list_stats?.stats_coloured_fields_type.length
              }
            >
              {renderStats(
                data?.field_number_list_stats?.stats_coloured_fields_type,
                global
              )}
            </div>
          )}
        </div>
        <div
          className={
            'bottom count-' +
            data?.field_number_list?.title_text_paragraph_type.length
          }
          ref={numberListRef}
          style={{ marginTop: marginTop }}
        >
          {renderItems(
            data?.field_number_list?.title_text_paragraph_type,
            data,
            global
          )}
        </div>
      </div>
    </div>
  );
};

export default NumberList;
